﻿import { Spinner as BsSpinner } from 'react-bootstrap';

export default function Spinner({ text }: { text?: string }) {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <BsSpinner animation="border" className="spinner-primary me-2" />
      {text && <span className="text-muted">{text}</span>}
    </div>
  );
}
